import KoobAvatar from '@koob/ui/src/components/KoobAvatar';

export default function ProfileCard({ user }) {
  // App user objects carry firstName/lastName, not a precomposed name.
  const name =
    user?.name ?? [user?.firstName, user?.lastName].filter(Boolean).join(' ');

  return (
    <div className="flex items-center space-x-4">
      <KoobAvatar
        size={16}
        rounded="full"
        src={user?.avatarUrl ?? '/img/avatar-placeholder.png'}
        alt={`${name}'s avatar`}
      />
      <div>
        <h2 className="text-xl font-bold">{name}</h2>
        <p className="text-gray-600">{user.email}</p>
      </div>
    </div>
  );
}
